import { environment } from '../environment'

export const prefixUrl = (url: string): string =>
  `${environment.REACT_APP_API_URL}${url}`
